
<script lang="ts">
	import { Router, Route } from "svelte-navigator";
	import { Styles } from "sveltestrap";
	import RouteGuard from "./components/RouteGuard.svelte";
	// import { ROL_SUPERADMIN } from "./evironment";
	import Index from "./Pages/index.svelte";
	import Login from "./Pages/login.svelte";
	import UsersList from "./Pages/usersList.svelte";
	import ThirdForm from "./Pages/thirdForm.svelte";
	import ThirdsList from "./Pages/thirdsList.svelte";
	import FilesManager from "./Pages/filesManager.svelte";
	import Settings from "./Pages/settings.svelte";
	import VehiclesList from "./Pages/vehiclesList.svelte";
	import VehicleForm from "./Pages/vehicleForm.svelte";
	import RegistersList from "./Pages/registersList.svelte";
	import DiligencesList from "./Pages/diligencesList.svelte";
	import DiligenceForm from "./Pages/diligence.svelte";
	import { SvelteToast } from "@zerodevx/svelte-toast";
	import MapList from "./Pages/mapList.svelte";
    import RegistersExternalAntecedentsList from "./Pages/registersExternalAntecedentsList.svelte";
    import RegistersDetainedList from "./Pages/registersDetainedList.svelte";
    import RegistersUnidentifiedPerson from "./Pages/registersUnidentifiedPerson.svelte";
    import Signer from "./Pages/signer.svelte";
    import RegistersLostObjectsList from "./Pages/registersLostObjectsList.svelte";

</script>

<Styles />

<Router primary={false}>

	<Route path="/login">
		<Login />
	</Route>

	<Route path="/">
		<RouteGuard>
			<Index />
		</RouteGuard>
	</Route>
	<Route path="/terceros">
		<RouteGuard>
			<ThirdsList />     
		</RouteGuard>
	</Route>
	<Route path="/mapas">
		<RouteGuard>
			<MapList />     
		</RouteGuard>
	</Route>
	<Route path="/register">
		<RouteGuard>
			<RegistersList />     
		</RouteGuard>
	</Route>
	<Route path="/antecedentesExternos">
		<RouteGuard>
			<RegistersExternalAntecedentsList />
		</RouteGuard>
	</Route>
	<Route path="/detenidos">
		<RouteGuard>
			<RegistersDetainedList />     
		</RouteGuard>
	</Route>
	<Route path="/objetosPerdidos">
		<RouteGuard>
			<RegistersLostObjectsList />     
		</RouteGuard>
	</Route>
	<Route path="/sinIdentificar">
		<RouteGuard>
			<RegistersUnidentifiedPerson />     
		</RouteGuard>
	</Route>
	<Route path="tercero/:id" let:params>
		<RouteGuard>
			<ThirdForm thirdId={params.id} />
		</RouteGuard>
	</Route>
	<Route path="/vehiculos">
		<RouteGuard>
			<VehiclesList />     
		</RouteGuard>
	</Route>
	<Route path="vehiculo/:id" let:params>
		<RouteGuard>
			<VehicleForm vehicleId={params.id} />
		</RouteGuard>
	</Route>
	<Route path="/usuarios">
		<RouteGuard>
			<UsersList />     
		</RouteGuard>
	</Route>
	<Route path="/settings">
		<RouteGuard>
			<Settings/>
		</RouteGuard>
	</Route>
	<Route path="/diligencias">
		<RouteGuard>
			<DiligencesList/>
		</RouteGuard>
	</Route>
	<Route path="/files">
		<RouteGuard>
			<FilesManager/>
		</RouteGuard>
	</Route>
	<Route path="/signer">
		<RouteGuard>
			<Signer/>
		</RouteGuard>
	</Route>
	<Route path="/diligencias/:id" let:params>
		<RouteGuard>
			<DiligenceForm diligenceId={params.id} />
		</RouteGuard>
	</Route>
	<Route path="*">
		NotFound 
	</Route>
</Router>

<SvelteToast />